import {useDeleteTaskDialogOptional} from '../contexts/DeleteTaskDialogContext'
import {DeleteTaskDialog} from './DeleteTaskDialog'

interface DeleteTaskDialogRenderedProps {
  /** When true, navigates back to the task list after deletion (used on task view page) */
  navigateOnDelete?: boolean
}

export function DeleteTaskDialogRendered({navigateOnDelete}: DeleteTaskDialogRenderedProps) {
  const deleteDialog = useDeleteTaskDialogOptional()
  if (!deleteDialog?.dialogState.isOpen || !deleteDialog.dialogState.taskId) return null
  const {taskId, repoOwner, repoName} = deleteDialog.dialogState
  return (
    <DeleteTaskDialog
      taskId={taskId}
      repoOwner={repoOwner}
      repoName={repoName}
      closeDialog={deleteDialog.closeDeleteDialog}
      navigateOnDelete={navigateOnDelete}
    />
  )
}
